// MemoAvatar.jsx

import React from 'react';
import ColorConstants from 'constants/ColorConstants'
import {
  AVATAR_SIZE
} from 'constants/DimensionsConstants';

function MemoAvatar(props) {
  const initial = props.initials ? props.initials.charAt(0) : "U";

  return (
    <div style={{ 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: AVATAR_SIZE,
      width: AVATAR_SIZE,
      backgroundColor: props.color || ColorConstants.ACTIVE_BUTTON_BLUE,
      color: "white",
      borderRadius: '50%',
      // fixed px: the em-based size varied with the surrounding text and
      // rendered too small; 12px fills the 18px circle proportionally
      fontSize: '12px',
      lineHeight: 1
      }}>
    {/* caps have no descender, so line-box centering rides ~0.06em high;
        nudge the glyph down to optically center it */}
    <span style={{transform: 'translateY(0.06em)'}}>{initial}</span>
  </div>
  );
}

export default MemoAvatar;
